var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-combobox',{attrs:{"items":_vm.datos,"label":"Seleccione la sede...","item-text":"nombre","hide-details":"","outlined":"","dense":""},model:{value:(_vm.modelo.idsede),callback:function ($$v) {_vm.$set(_vm.modelo, "idsede", $$v)},expression:"modelo.idsede"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }